<style scoped>
@import url("../assets/css/index.css");
</style>

<template>
    <div class="home-content common-home-content max-640">
        <div class="main-jieqi-container ice_bg" v-show="show">       
            <div class="jieqi_data">
                <div class="section_jq">
                  <h2>{{jieqi_data.jieqi}}养生</h2>
                  <div class="p-content pr">  
                      <h3>饮食调养</h3>
                      {{jieqi_data.ysty}}
                      <h3>穿衣助手</h3>
                      {{jieqi_data.cyzs}}
                      <h3>起居作息</h3>
                      {{jieqi_data.qjzx}}
                      <h3>精神调养</h3>
                      {{jieqi_data.jsty}}
                      <h3>养生要点</h3>
                      {{jieqi_data.ysyd}}
                  </div>
              </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  data() {
    return {
      locData: {},
      show: false,
      jieqi_data: {}
    };
  },
  created() {
    this.loadinti();
    window.appBack = ()=> this.pageback();
  },
  methods: {
    loadinti(){
        var that = this;
        that.$api.get("/health/getlunardata", "").then(function(res) {
            that.locData = res.data.data;
            that.jieqi_data = that.locData.jieqi_data;
            that.jieqi_data['jieqi'] = that.locData.jieqi;
            that.show = true;
            
        });
    },
    pageback(){
        var exist_disease = this.$utils.getUrlKey("d");
        if(exist_disease){
          this.$router.push({ path: "/?d="+exist_disease});
        }else{
          this.$router.push({ path: "/"});
        }
        return true;
    }  
  }
}
</script>

